const Constants = {
  API: "https://vip.netvideogirls.com/api/",
  // API: "http://192.168.86.43:4000/",
  // APIV1: "http://192.168.86.43:4000/",
  HOME: "/members/",
  STATIC: "https://vip.netvideogirls.com/assets/",
  VIDEO_PREVIEWS: "https://vip.netvideogirls.com/video-previews/",
  AF_STATIC: "https://static.addfriends.com/vip/posters/",
  SORT_FAV: {
    date_added: "Date Favorited",
    most_viewed: "Most Viewed",
    most_popular: "Most Popular",
    most_recent: "Most Recent",
  },
  SORT: {
    most_viewed: "Most Viewed",
    most_popular: "Most Popular",
    most_recent: "Most Recent",
  },
  SORT_MOD: {
    "a-z": "A-Z",
    newest_girls: "Newest Girls",
    model_rank: "Model Rank",
    most_liked: "Most Liked",
    most_viewed: "Most Viewed",
  },
};
export default Constants;
